import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaSignOutAlt, FaTruck, FaCheckCircle, FaArrowLeft, FaBoxes, FaMoneyBill } from 'react-icons/fa';
import '../styles/HamburgerMenu.css';

const HamburgerMenu = ({ username, carNumber, handleLogout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const isActive = (path) => location.pathname === path;

    return (
        <>
            <div className={`hamburger-icon ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                {isOpen ? <FaArrowLeft /> : <FaBars />}
            </div>
            <div className={`side-menu ${isOpen ? 'open' : ''}`}>
                <div className="profile-section">
                    <h3>รถส่งเบอร์ {carNumber}</h3>
                    <p>@{username}</p>
                </div>
                <ul className="menu-items">
                    <li className={isActive('/') ? 'active' : ''}>
                        <Link to="/" onClick={() => setIsOpen(false)}>
                            <FaTruck /> งานรอส่ง
                        </Link>
                    </li>
                    <li className={isActive('/completed') ? 'active' : ''}>
                        <Link to="/completed" onClick={() => setIsOpen(false)}>
                            <FaCheckCircle /> งานที่จบแล้ว
                        </Link>
                    </li>
                    <li className={isActive('/returned') ? 'active' : ''}>
                        <Link to="/returned" onClick={() => setIsOpen(false)}>
                            <FaBoxes /> ของเหลือกลับร้าน
                        </Link>
                    </li>
                    <li className={isActive('/billing') ? 'active' : ''}>
                        <Link to="/billing" onClick={() => setIsOpen(false)}>
                            <FaMoneyBill /> คิดเงิน
                        </Link>
                    </li>
                    {/* เพิ่มปุ่ม Logout */}
                    <li onClick={handleLogout} className="logout-button">
                        <FaSignOutAlt /> ออกจากระบบ
                    </li>
                </ul>
            </div>
        </>
    );
};

export default HamburgerMenu;
